// Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS

import AllImportedElementsNotification from '@/components/notifications/AllImportedElementsNotification.vue';
import DefaultNotification from '@/components/notifications/DefaultNotification.vue';
import MultipleUsersJoinWorkspaceNotification from '@/components/notifications/MultipleUsersJoinWorkspaceNotification.vue';
import NewDeviceNotification from '@/components/notifications/NewDeviceNotification.vue';
import NewVersionAvailableNotification from '@/components/notifications/NewVersionAvailableNotification.vue';
import UserJoinWorkspaceNotification from '@/components/notifications/UserJoinWorkspaceNotification.vue';
import UserSharedDocumentNotification from '@/components/notifications/UserSharedDocumentNotification.vue';
import WorkspaceAccessNotification from '@/components/notifications/WorkspaceAccessNotification.vue';
import WorkspaceRoleChangedNotification from '@/components/notifications/WorkspaceRoleChangedNotification.vue';

export const Notifications = {
  AllImportedElementsNotification,
  DefaultNotification,
  NewDeviceNotification,
  MultipleUsersJoinWorkspaceNotification,
  UserJoinWorkspaceNotification,
  UserSharedDocumentNotification,
  WorkspaceAccessNotification,
  WorkspaceRoleChangedNotification,
  NewVersionAvailableNotification,
};
